import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["current", "form"]

  toggleForm(event) {
    this.formTarget.classList.toggle('d-none');
    this.formTarget.classList.toggle('d-flex');
    this.currentTarget.classList.toggle('d-none');
    if (event.currentTarget.innerText === "ANNULER") {
      event.currentTarget.innerText = "EDITER";
    } else {
      event.currentTarget.innerText = "ANNULER";
    }
  }
}